import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { CardActionArea, Paper } from '@mui/material';

import { useNavigate } from 'react-router-dom'

import { useAuthContext } from '../hooks/useAuthContext'
import DashCard from '../components/DashCard'
import { Container, Box, Grid } from '@mui/material'
import ConstructionIcon from '@mui/icons-material/Construction'
import SchoolIcon from '@mui/icons-material/School'
import AssignmentIcon from '@mui/icons-material/Assignment'
import PersonIcon from '@mui/icons-material/Person'
import SummarizeIcon from '@mui/icons-material/Summarize'
import GradeIcon from '@mui/icons-material/Grade'
import HeadphonesIcon from '@mui/icons-material/Headphones'
import ModeEditIcon from '@mui/icons-material/ModeEdit'
import CreditCardIcon from '@mui/icons-material/CreditCard'
import LogoutCard from '../components/LogoutCard'
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import { Typography } from '@mui/material'
import EscalatorWarningIcon from '@mui/icons-material/EscalatorWarning';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PublicIcon from '@mui/icons-material/Public';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import AssessmentIcon from '@mui/icons-material/Assessment';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import { useState, useEffect } from 'react'
import QuizIcon from '@mui/icons-material/Quiz';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SickIcon from '@mui/icons-material/Sick';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import GradingIcon from '@mui/icons-material/Grading';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PeopleIcon from '@mui/icons-material/People';
import LogoutIcon from '@mui/icons-material/Logout';
import { useLogout } from '../hooks/useLogout'
import GavelIcon from '@mui/icons-material/Gavel';
export default function Dashboard() {

  const { accessLevel, studentID } = useAuthContext()
  const { logout } = useLogout()
  document.title = 'Private Candidates Online';





  return (
    <Container maxWidth="xl">

      <Box mb={5} />




      <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}>




        <Grid item xs={12}>

          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{

              maxWidth: '95%',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}
          >
            <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'left' }}>

              <ul>


                <li><b>Academic Consultations:</b> Should you have any academic, qualification, paper combination or general enquiry, you can book an online consultation and one of British Internationals College's academic consultants will assist you.</li>
                <li><b>Cambridge Application:</b> Candidates can apply for Cambridge International External Assessments online (Cambridge Examinations).  </li>
                <li><b>Entry Status:</b> Candidates can view their application status online. .  </li>



              </ul>
            </Typography>



          </Box>


        </Grid>

        <Grid item xs={4} sm={4} md={4} lg={4} xl={3}>



          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"

          >
            <DashCard link={"/consult/book"} cardName={"Book Academic Consultation"} cardIcon={<PeopleIcon />} />
          </Box>

        </Grid>

        <Grid item xs={4} sm={4} md={4} lg={4} xl={3}>



          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"

          >
            <DashCard link={"/cambridge/apply"} cardName={"Cambridge Application "} cardIcon={<AssessmentIcon />} />
          </Box>

        </Grid>

        <Grid item xs={4} sm={4} md={4} lg={4} xl={3}>



          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"

          >
            <DashCard link={"/cambridge/status"} cardName={"View Entry Status"} cardIcon={<VisibilityIcon />} />
          </Box>

        </Grid>

        <Grid item xs={4} sm={4} md={4} lg={4} xl={3}>



          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"

          >

            <Card sx={{
              width: 300,
              color: 'white',
              maxWidth: 250,
              alignItems: 'center',
              height: 80,
              bgcolor: 'secondary.main',

            }}>



              <CardActionArea onClick={() => logout()} >


                <CardContent>
                  <Typography gutterBottom variant="h5" component="div" textAlign="center">
                    <LogoutIcon /> Logout
                  </Typography>
                </CardContent>

              </CardActionArea>





            </Card>
          </Box>

        </Grid>

      </Grid>



      <Box mb={5} />



    </Container >

  )
}
